// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__17hGq","actionsCol":"EnrolledClinics_actionsCol__kBl0b"};